<template>
  <div class="eod-setting-container">

    <div class="header-container" style="margin-bottom: 2rem;">
      <span>EOD SETTINGS</span>
    </div>

    <div class="eod_setting__content">
      <div class="d-flex flex-column">
        <div class="peiso__flex_table">
          <div class="table__header d-flex min-h-40">

            <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-40 w-100"></div>
            <div class="vertical-separator"></div>
            <div class="header__cell d-flex align-items-center justify-content-center px-1rem h-40 w-100 mw-200">
              <span>ACTION</span>
            </div>
          </div>
        </div>

        <div class="peiso__flex_table">
          <div class="table__row d-flex">

            <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100">
              <span>Comp value visibility</span>
            </div>
            <div class="vertical-separator"></div>
            <div class="header__cell d-flex align-items-center justify-content-center px-1rem h-100 w-100 mw-200">
              <el-switch v-model="form.compValue" active-text="Show" inactive-text="Hide" size="large" />
            </div>
          </div>
        </div>

        <div class="peiso__flex_table">
          <div class="table__row d-flex">

            <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100">
              <span>Editable cover field</span>
            </div>
            <div class="vertical-separator"></div>
            <div class="header__cell d-flex align-items-center justify-content-center px-1rem h-100 w-100 mw-200">
              <el-switch v-model="form.isEditCover" active-text="Yes" inactive-text="No" size="large" />
            </div>
          </div>
        </div>

        <div v-if="INSTANCE_TYPE == 'main' || INSTANCE_TYPE == 'sandbox'" class="peiso__flex_table">
          <div class="table__row d-flex">

            <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100 eod-notes-field">
              <el-input type="text" v-model="form.accommodationRevenueLabel" class="peiso-input-default"></el-input>
              <!-- <span>Accommodation Revenue</span> -->
            </div>

            <div class="vertical-separator"></div>
            <div class="header__cell d-flex align-items-center justify-content-center px-1rem h-100 w-100 mw-200">
              <el-switch v-model="form.accommodationRevenue" active-text="Show" inactive-text="Hide" size="large" />
            </div>
          </div>
        </div>
        <div v-if="INSTANCE_TYPE == 'main' || INSTANCE_TYPE == 'sandbox'" class="peiso__flex_table">
          <div class="table__row d-flex">

            <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100 eod-notes-field">
            <!-- <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100 eod-notes-field"> -->
              <el-input type="text" v-model="form.accommodationRateLabel" class="peiso-input-default"></el-input>
              <!-- <span>Accommodation Rate</span> -->
            </div>

            <div class="vertical-separator"></div>
            <div class="header__cell d-flex align-items-center justify-content-center px-1rem h-100 w-100 mw-200">
              <el-switch v-model="form.accommodationRate" active-text="Show" inactive-text="Hide" size="large" />
            </div>
          </div>
        </div>

        <div class="peiso__flex_table">
          <div class="table__row d-flex">
            <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100 eod-notes-field">
              <el-input type="text" v-model="form.purchasesLabel" class="peiso-input-default"></el-input>
            </div>

            <div class="vertical-separator"></div>
            <div class="header__cell d-flex align-items-center justify-content-center px-1rem h-100 w-100 mw-200">
              <el-switch v-model="form.purchases" active-text="Show" inactive-text="Hide" size="large" />
            </div>
          </div>  
        </div>

        <div class="peiso__flex_table">
          <div class="table__row d-flex">
            <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100 eod-notes-field">
              <el-input type="text" v-model="form.weekToDateLabel" class="peiso-input-default"></el-input>
            </div>

            <div class="vertical-separator"></div>
            <div class="header__cell d-flex align-items-center justify-content-center px-1rem h-100 w-100 mw-200">
              <el-switch v-model="form.weekToDate" active-text="Show" inactive-text="Hide" size="large" />
            </div>
          </div>  
        </div>

        <div class="peiso__flex_table">
          <div class="table__row d-flex">

            <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100">
              <span>REPORT NOTES</span>
            </div>
          </div>
        </div>
        <div class="peiso__flex_table">
          <div class="table__row d-flex">
            <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100 eod-notes-field">
              <el-input type="text" v-model="form.managerServiceLabel" class="peiso-input-default"></el-input>
            </div>
            <div class="vertical-separator"></div>
            <div class="header__cell d-flex align-items-center justify-content-center px-1rem h-100 w-100 mw-200">
              <el-switch v-model="form.managerService" active-text="Show" inactive-text="Hide" size="large" />
            </div>
          </div>
        </div>

        <div class="peiso__flex_table">
          <div class="table__row d-flex">
            <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100 eod-notes-field">
              <el-input type="text" v-model="form.labourWeekToDateLabel" class="peiso-input-default"></el-input>
            </div>
            <div class="vertical-separator"></div>
            <div class="header__cell d-flex align-items-center justify-content-center px-1rem h-100 w-100 mw-200">
              <el-switch v-model="form.labourWeekToDate" active-text="Show" inactive-text="Hide" size="large" />
            </div>
          </div>
        </div>

        <div class="peiso__flex_table">
          <div class="table__row d-flex">

            <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100 eod-notes-field">
              <el-input type="text" v-model="form.bevServiceLabel" class="peiso-input-default"></el-input>
            </div>
            <div class="vertical-separator"></div>
            <div class="header__cell d-flex align-items-center justify-content-center px-1rem h-100 w-100 mw-200">
              <el-switch v-model="form.bevService" active-text="Show" inactive-text="Hide" size="large" />
            </div>
          </div>
        </div>
        <div class="peiso__flex_table">
          <div class="table__row d-flex">

            <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100 eod-notes-field">
              <el-input type="text" v-model="form.venueVibeLabel" class="peiso-input-default"></el-input>
            </div>
            <div class="vertical-separator"></div>
            <div class="header__cell d-flex align-items-center justify-content-center px-1rem h-100 w-100 mw-200">
              <el-switch v-model="form.venueVibe" active-text="Show" inactive-text="Hide" size="large" />
            </div>
          </div>
        </div>
        <div class="peiso__flex_table">
          <div class="table__row d-flex">

            <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100">
              <span>Weather Records</span>
            </div>
            <div class="vertical-separator"></div>
            <div class="header__cell d-flex align-items-center justify-content-center px-1rem h-100 w-100 mw-200">
              <el-switch v-model="form.weatherRecords" active-text="Show" inactive-text="Hide" size="large" />
            </div>
          </div>
        </div>
        <div class="peiso__flex_table">
          <div class="table__row d-flex">

            <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100 eod-notes-field">
              <el-input type="text" v-model="form.largePartiesLabel" class="peiso-input-default"></el-input>
            </div>
            <div class="vertical-separator"></div>
            <div class="header__cell d-flex align-items-center justify-content-center px-1rem h-100 w-100 mw-200">
              <el-switch v-model="form.largeParties" active-text="Show" inactive-text="Hide" size="large" />
            </div>
          </div>
        </div>
        <div class="peiso__flex_table">
          <div class="table__row d-flex">

            <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100 eod-notes-field">
              <el-input type="text" v-model="form.vipLabel" class="peiso-input-default"></el-input>
            </div>
            <div class="vertical-separator"></div>
            <div class="header__cell d-flex align-items-center justify-content-center px-1rem h-100 w-100 mw-200">
              <el-switch v-model="form.vip" active-text="Show" inactive-text="Hide" size="large" />
            </div>
          </div>
        </div>
        <div class="peiso__flex_table">
          <div class="table__row d-flex">

            <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100 eod-notes-field">
              <el-input type="text" v-model="form.staffLabel" class="peiso-input-default"></el-input>
            </div>
            <div class="vertical-separator"></div>
            <div class="header__cell d-flex align-items-center justify-content-center px-1rem h-100 w-100 mw-200">
              <el-switch v-model="form.staff" active-text="Show" inactive-text="Hide" size="large" />
            </div>
          </div>
        </div>
        <div class="peiso__flex_table">
          <div class="table__row d-flex">

            <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100 eod-notes-field">
              <el-input type="text" v-model="form.trainingLabel" class="peiso-input-default"></el-input>
            </div>
            <div class="vertical-separator"></div>
            <div class="header__cell d-flex align-items-center justify-content-center px-1rem h-100 w-100 mw-200">
              <el-switch v-model="form.training" active-text="Show" inactive-text="Hide" size="large" />
            </div>
          </div>
        </div>
        <div class="peiso__flex_table">
          <div class="table__row d-flex">

            <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100 eod-notes-field">
              <el-input type="text" v-model="form.compExpLabel" class="peiso-input-default"></el-input>
            </div>
            <div class="vertical-separator"></div>
            <div class="header__cell d-flex align-items-center justify-content-center px-1rem h-100 w-100 mw-200">
              <el-switch v-model="form.compExp" active-text="Show" inactive-text="Hide" size="large" />
            </div>
          </div>
        </div>
        <div class="peiso__flex_table">
          <div class="table__row d-flex align-items-center">

            <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100 eod-notes-field">
              <el-input type="text" v-model="form.whsLabel" class="peiso-input-default"></el-input>
            </div>
            <div class="vertical-separator"></div>
            <div class="header__cell d-flex align-items-center justify-content-center px-1rem h-100 w-100 mw-200">
              <el-switch v-model="form.whs" active-text="Show" inactive-text="Hide" size="large" />
            </div>
          </div>
        </div>
        <div class="peiso__flex_table">
          <div class="table__row d-flex">

            <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100 eod-notes-field">
              <el-input type="text" v-model="form.repairsLabel" class="peiso-input-default"></el-input>
            </div>
            <div class="vertical-separator"></div>
            <div class="header__cell d-flex align-items-center justify-content-center px-1rem h-100 w-100 mw-200">
              <el-switch v-model="form.repairs" active-text="Show" inactive-text="Hide" size="large" />
            </div>
          </div>
        </div>

        <div class="peiso__flex_table">
          <div class="table__row d-flex">

            <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100 eod-notes-field">
              <el-input type="text" v-model="form.othersLabel" class="peiso-input-default"></el-input>
            </div>
            <div class="vertical-separator"></div>
            <div class="header__cell d-flex align-items-center justify-content-center px-1rem h-100 w-100 mw-200">
              <el-switch v-model="form.others" active-text="Show" inactive-text="Hide" size="large" />
            </div>
          </div>
        </div>

        <div class="peiso__flex_table" >
          <div class="table__row d-flex">

            <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100 eod-notes-field">
              <el-input type="text" v-model="form.execSummaryLabel" class="peiso-input-default"></el-input>
            </div>
            <div class="vertical-separator"></div>
            <div class="header__cell d-flex align-items-center justify-content-center px-1rem h-100 w-100 mw-200">
              <el-switch v-model="form.execSummary" active-text="Show" inactive-text="Hide" size="large" />
            </div>
          </div>
        </div>

        <div class="peiso__flex_table">
          <div class="table__row d-flex">

            <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100 eod-notes-field">
              <el-input type="text" v-model="form.roomUsedLabel" class="peiso-input-default"></el-input>
            </div>
            <div class="vertical-separator"></div>
            <div class="header__cell d-flex align-items-center justify-content-center px-1rem h-100 w-100 mw-200">
              <el-switch v-model="form.roomUsed" active-text="Show" inactive-text="Hide" size="large" />
            </div>
          </div>
        </div>

        <div class="peiso__flex_table">
          <div class="table__row d-flex">

            <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100 eod-notes-field">
              <el-input type="text" v-model="form.availableRoomsCountLabel" class="peiso-input-default"></el-input>
            </div>
            <div class="vertical-separator"></div>
            <div class="header__cell d-flex align-items-center justify-content-center px-1rem h-100 w-100 mw-200">
              <el-switch v-model="form.availableRoomsCount" active-text="Show" inactive-text="Hide" size="large" />
            </div>
          </div>
        </div>


        <div class="peiso__flex_table">
          <div class="table__row d-flex">

            <div class="header__cell d-flex align-items-center justify-content-start px-1rem h-100 w-100">
              <span>Upload message</span>
            </div>
            <div class="vertical-separator"></div>
            <div class="header__cell d-flex align-items-center justify-content-center px-1rem h-100 w-100 mw-200">
              <el-switch v-model="form.uploadImage" active-text="Show" inactive-text="Hide" size="large" />
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-center m-top-2rem">
        <el-button v-if="!isLoading" type="peiso-primary-pink-border-only" class="save-button px-3rem"
          @click="saveEodSetting">Save settings</el-button>
        <el-button v-if="isLoading" type="peiso-primary-pink-border-only" class="save-button px-3rem cursor-disable"><i
            class="el-icon-loading"></i> Saving...</el-button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import 'static/scss/fonts/fonts';
@import 'static/scss/colors';

.eod-setting-container {
  .save-button {
    height: 55px;
    @include montserrat-font(26px, normal, 400, $pink1)
  }
}
</style>

<script>
import dashboard from '@/api/dashboard'
import utils from '@/utils/utils'
export default {
  data() {
    return {
      INSTANCE_TYPE: process.env.INSTANCE_TYPE,
      form: {
        compValue: true,
        managerService: true,
        bevService: true,
        venueVibe: true,
        largeParties: true,
        vip: true,
        staff: true,
        training: true,
        compExp: true,
        whs: true,
        repairs: true,
        others: true,
        uploadImage: true,
        isEditCover: true,
        accommodationRevenue: true,
        roomUsed: false,
        availableRoomsCount: false,
        accommodationRate: true,
        managerServiceLabel: 'Manager Service Notes',
        bevServiceLabel: 'Bev Service Notes',
        venueVibeLabel: 'Venue Vibe / Energy FOH',
        largePartiesLabel: 'Large Parties / Events',
        vipLabel: 'VIP notes',
        staffLabel: 'Staff notes',
        trainingLabel: 'Training notes',
        compExpLabel: 'Comp Explanations notes',
        whsLabel: 'WHS, Employee Incidental, & Safety Notes',
        repairsLabel: 'Repairs & Maint / IT Issues',
        othersLabel: 'OTHER: any other feedback etc',
        weatherRecords: true,
        weatherRecordsLabel: 'Weather record',
        accommodationRevenueLabel: "Accommodation Revenue",
        roomUsedLabel: 'Room Used',
        availableRoomsCountLabel: 'Room Available',
        accommodationRateLabel: "Accommodation Rate",
        labourWeekToDate: false,
        labourWeekToDateLabel: "Labour WTD",
        execSummary: false,
        execSummaryLabel: 'Exec Summary',
        purchases: true,
        weekToDate: true,
        purchasesLabel: 'Purchases',
        weekToDateLabel: 'Week to date total'  
      },
      isLoading: false,
    }
  },

  methods: {
    saveEodSetting() {
      this.isLoading = true
      var data = {
        compValue: this.form.compValue ? 1 : 0,
        managerService: this.form.managerService ? 1 : 0,
        bevService: this.form.bevService ? 1 : 0,
        venueVibe: this.form.venueVibe ? 1 : 0,
        largeParties: this.form.largeParties ? 1 : 0,
        vip: this.form.vip ? 1 : 0,
        staff: this.form.staff ? 1 : 0,
        training: this.form.training ? 1 : 0,
        compExp: this.form.compExp ? 1 : 0,
        whs: this.form.whs ? 1 : 0,
        repairs: this.form.repairs ? 1 : 0,
        others: this.form.others ? 1 : 0,
        uploadImage: this.form.uploadImage ? 1 : 0,
        isEditCover: this.form.isEditCover ? 1 : 0,
        accommodationRevenue: this.form.accommodationRevenue ? 1 : 0,
        usedRoomsCountToggle: this.form.roomUsed ? 1 : 0,
        availableRoomsCountToggle: this.form.availableRoomsCount ? 1 : 0,
        accommodationRate: this.form.accommodationRate ? 1 : 0,
        purchases: this.form.purchases ? 1 : 0,
        weekToDate: this.form.weekToDate ? 1 : 0,
        labourWeekToDate:  this.form.labourWeekToDate ? 1 : 0,
        execSummary: this.form.execSummary ? 1 : 0,
        managerServiceLabel: this.form.managerServiceLabel ? this.form.managerServiceLabel : 'Manager Service Notes',
        bevServiceLabel: this.form.bevServiceLabel ? this.form.bevServiceLabel : 'Bev Service Notes',
        venueVibeLabel: this.form.venueVibeLabel ? this.form.venueVibeLabel : 'Venue Vibe / Energy FOH',
        largePartiesLabel: this.form.largePartiesLabel ? this.form.largePartiesLabel : 'Large Parties / Events',
        vipLabel: this.form.vipLabel ? this.form.vipLabel : 'VIP notes',
        staffLabel: this.form.staffLabel ? this.form.staffLabel : 'Staff notes',
        trainingLabel: this.form.trainingLabel ? this.form.trainingLabel : 'Training notes',
        compExpLabel: this.form.compExpLabel ? this.form.compExpLabel : 'Comp Explanations notes',
        whsLabel: this.form.whsLabel ? this.form.whsLabel : 'WHS, Employee Incidental, & Safety Notes',
        repairsLabel: this.form.repairsLabel ? this.form.repairsLabel : 'Repairs & Maint / IT Issues',
        othersLabel: this.form.othersLabel ? this.form.othersLabel : 'OTHER: any other feedback etc',
        weatherRecords: this.form.weatherRecords ? 1 : 0,
        weatherRecordsLabel: this.form.weatherRecordsLabel ? this.form.weatherRecordsLabel : 'Weather record',
        accommodationRevenueLabel: this.form.accommodationRevenueLabel ? this.form.accommodationRevenueLabel : 'Accommodation Revenue',
        usedRoomsCountLabel: this.form.roomUsedLabel ? this.form.roomUsedLabel : 'Room Used',
        availableRoomsCountLabel: this.form.availableRoomsCountLabel ? this.form.availableRoomsCountLabel : 'Room Available',
        accommodationRateLabel: this.form.accommodationRateLabel ? this.form.accommodationRateLabel : 'Accommodation Rate',
        labourWeekToDateLabel: this.form.labourWeekToDate ? this.form.labourWeekToDateLabel : "Labour WTD",
        execSummaryLabel: this.form.execSummaryLabel ? this.form.execSummaryLabel : 'Exec Summary',
        purchasesLabel: this.form.purchasesLabel ? this.form.purchasesLabel : 'Purchases',
        weekToDateLabel: this.form.weekToDateLabel ? this.form.weekToDateLabel : 'Week to date total'
      }

      dashboard.saveEodSetting(data).then((res) => {
        this.isLoading = false
        if (res.data.code == 0) {

          var form = {
            compValue: res.data.data.compValue ? true : false,
            managerService: res.data.data.managerService ? true : false,
            bevService: res.data.data.bevService ? true : false,
            venueVibe: res.data.data.venueVibe ? true : false,
            largeParties: res.data.data.largeParties ? true : false,
            vip: res.data.data.vip ? true : false,
            staff: res.data.data.staff ? true : false,
            training: res.data.data.training ? true : false,
            compExp: res.data.data.compExp ? true : false,
            whs: res.data.data.whs ? true : false,
            repairs: res.data.data.repairs ? true : false,
            others: res.data.data.others ? true : false,
            uploadImage: res.data.data.uploadImage ? true : false,
            isEditCover: res.data.data.isEditCover ? true : false,
            accommodationRevenue: res.data.data.accommodationRevenue ? true : false,
            roomUsed: res.data.data.usedRoomsCountToggle ? true : false,
            availableRoomsCount: res.data.data.availableRoomsCountToggle ? true : false,
            accommodationRate: res.data.data.accommodationRate ? true : false,
            purchases: res.data.data.purchases ? true : false,
            weekToDate: res.data.data.weekToDate ? true : false,
            managerServiceLabel: res.data.data.managerServiceLabel ? res.data.data.managerServiceLabel : 'Manager Service Notes',
            bevServiceLabel: res.data.data.bevServiceLabel ? res.data.data.bevServiceLabel : 'Bev Service Notes',
            venueVibeLabel: res.data.data.venueVibeLabel ? res.data.data.venueVibeLabel : 'Venue Vibe / Energy FOH',
            largePartiesLabel: res.data.data.largePartiesLabel ? res.data.data.largePartiesLabel : 'Large Parties / Events',
            vipLabel: res.data.data.vipLabel ? res.data.data.vipLabel : 'VIP notes',
            staffLabel: res.data.data.staffLabel ? res.data.data.staffLabel : 'Staff notes',
            trainingLabel: res.data.data.trainingLabel ? res.data.data.trainingLabel : 'Training notes',
            compExpLabel: res.data.data.compExpLabel ? res.data.data.compExpLabel : 'Comp Explanations notes',
            whsLabel: res.data.data.whsLabel ? res.data.data.whsLabel : 'WHS, Employee Incidental, & Safety Notes',
            repairsLabel: res.data.data.repairsLabel ? res.data.data.repairsLabel : 'Repairs & Maint / IT Issues',
            othersLabel: res.data.data.othersLabel ? res.data.data.othersLabel : 'OTHER: any other feedback etc',
            weatherRecords: res.data.data.weatherRecords ? true : false,
            weatherRecordsLabel: res.data.data.weatherRecordsLabel ? res.data.data.weatherRecordsLabel : 'Weather record',
            accommodationRevenueLabel: res.data.data.accommodationRevenueLabel ? res.data.data.accommodationRevenueLabel : 'Accommodation Revenue',
            availableRoomsCountLabel: res.data.data.availableRoomsCountLabel ? res.data.data.availableRoomsCountLabel : 'Room Available',
            roomUsedLabel: res.data.data.usedRoomsCountLabel ? res.data.data.usedRoomsCountLabel : 'Room Used',
            accommodationRateLabel: res.data.data.accommodationRateLabel ? res.data.data.accommodationRateLabel : 'Accommodation Rate',
            labourWeekToDate:  res.data.data.labourWeekToDate ? true : false,
            labourWeekToDateLabel: res.data.data.labourWeekToDate ? res.data.data.labourWeekToDateLabel : "Labour WTD",
            execSummary: res.data.data.execSummary ? true : false,
            execSummaryLabel: res.data.data.execSummaryLabel ? res.data.data.execSummaryLabel : 'Exec Summary',
            purchasesLabel: res.data.data.purchasesLabel ? res.data.data.purchasesLabel : 'Purchases',
            weekToDateLabel: res.data.data.weekToDateLabel ? res.data.data.weekToDateLabel : 'Week to date total'
          }

          this.form = form

          console.log('this.form: ', this.form);
          utils.alert2('', 'EOD settings successfully saved.', 'success')
        }
      })
    },

    async getEodSetting() {
      dashboard.getEodSetting().then((res) => {
        var form = {
          compValue: res.data.data.compValue ? true : false,
          managerService: res.data.data.managerService ? true : false,
          bevService: res.data.data.bevService ? true : false,
          venueVibe: res.data.data.venueVibe ? true : false,
          largeParties: res.data.data.largeParties ? true : false,
          vip: res.data.data.vip ? true : false,
          staff: res.data.data.staff ? true : false,
          training: res.data.data.training ? true : false,
          compExp: res.data.data.compExp ? true : false,
          whs: res.data.data.whs ? true : false,
          repairs: res.data.data.repairs ? true : false,
          others: res.data.data.others ? true : false,
          uploadImage: res.data.data.uploadImage ? true : false,
          isEditCover: res.data.data.isEditCover ? true : false,
          roomUsed: res.data.data.usedRoomsCountToggle ? true : false,
          availableRoomsCount: res.data.data.availableRoomsCountToggle ? true : false,
          accommodationRevenue: res.data.data.accommodationRevenue ? true : false,
          accommodationRate: res.data.data.accommodationRate ? true : false,
          purchases: res.data.data.purchases ? true : false,
          weekToDate: res.data.data.weekToDate ? true : false,
          managerServiceLabel: res.data.data.managerServiceLabel ? res.data.data.managerServiceLabel : 'Manager Service Notes',
          bevServiceLabel: res.data.data.bevServiceLabel ? res.data.data.bevServiceLabel : 'Bev Service Notes',
          venueVibeLabel: res.data.data.venueVibeLabel ? res.data.data.venueVibeLabel : 'Venue Vibe / Energy FOH',
          largePartiesLabel: res.data.data.largePartiesLabel ? res.data.data.largePartiesLabel : 'Large Parties / Events',
          vipLabel: res.data.data.vipLabel ? res.data.data.vipLabel : 'VIP notes',
          staffLabel: res.data.data.staffLabel ? res.data.data.staffLabel : 'Staff notes',
          trainingLabel: res.data.data.trainingLabel ? res.data.data.trainingLabel : 'Training notes',
          compExpLabel: res.data.data.compExpLabel ? res.data.data.compExpLabel : 'Comp Explanations notes',
          whsLabel: res.data.data.whsLabel ? res.data.data.whsLabel : 'WHS, Employee Incidental, & Safety Notes',
          repairsLabel: res.data.data.repairsLabel ? res.data.data.repairsLabel : 'Repairs & Maint / IT Issues',
          othersLabel: res.data.data.othersLabel ? res.data.data.othersLabel : 'OTHER: any other feedback etc',
          weatherRecords: res.data.data.weatherRecords ? true : false,
          weatherRecordsLabel: res.data.data.weatherRecordsLabel ? res.data.data.weatherRecordsLabel : 'Weather record',
          accommodationRevenueLabel: res.data.data.accommodationRevenueLabel ? res.data.data.accommodationRevenueLabel : 'Accommodation Revenue',
          accommodationRateLabel: res.data.data.accommodationRateLabel ? res.data.data.accommodationRateLabel : 'Accommodation Rate',
          availableRoomsCountLabel: res.data.data.availableRoomsCountLabel ? res.data.data.availableRoomsCountLabel : 'Room Available',
          roomUsedLabel: res.data.data.usedRoomsCountLabel ? res.data.data.usedRoomsCountLabel : 'Room Used',
          labourWeekToDate:  res.data.data.labourWeekToDate ? true : false,
          labourWeekToDateLabel: res.data.data.labourWeekToDate ? res.data.data.labourWeekToDateLabel : "Labour WTD",
          execSummary: res.data.data.execSummary ? true : false,
          execSummaryLabel: res.data.data.execSummaryLabel ? res.data.data.execSummaryLabel : 'Exec Summary',
          purchasesLabel: res.data.data.purchasesLabel ? res.data.data.purchasesLabel : 'Purchases',
          weekToDateLabel: res.data.data.weekToDateLabel ? res.data.data.weekToDateLabel : 'Week to date total'
        }

        this.form = form
      })
    },


  },

  mounted() {
    this.getEodSetting()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/eodSetting.vue